import React from "react";
import SidebarSearchHeader from "./SidebarSearchHeader";

function SearchResultsSidebar() {
  return (
    <div className="sidebar search-results-sidebar">
      <SidebarSearchHeader alwaysShowFilters />
    </div>
  );
}

export default SearchResultsSidebar;
